export default __webpack_public_path__ + "static/media/thum_5.23143945.png";